import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/authentication/services/authentication.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);
  const bearerToken = authenticationService.getBearerToken();

  if (bearerToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
  }

  return next(req);
};
